<template>
  <div class="form-subtitle">
    <span
      v-if="!!prefix"
      v-text="`${prefix} `"
    />
    <app-i18n
      v-if="i18nCode"
      class="form-subtitle__caption"
      tag="span"
      :code="i18nCode"
    />
    <span
      v-if="caption"
      class="form-subtitle__caption"
      v-text="caption"
    />
    <span
      v-if="required"
      v-text="' *'"
    />
    <span
      v-if="!!suffix"
      v-text="` ${suffix}`"
    />
  </div>
</template>

<script>
export default {
  name: 'appFormSubtitle',
  props: {
    i18nCode: String,
    caption: String,
    required: Boolean,
    prefix: String,
    suffix: String,
  },
}
</script>

<style lang="scss" scoped>
.form-subtitle {
  --size: 14px;

  border-left: 2px solid #2acccc;
  padding-left: 4px;
  margin: 24px 0 16px 4px;
  text-align: left;
  text-transform: uppercase;
  font-size: var(--size);
  height: var(--size);
  line-height: var(--size);
  font-weight: 500;
}
</style>
